import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>FireGram</h1>
      <h2>Your Pictures</h2>
      <p>Upload and share awesome sights.</p>
    </div>
  )
}

export default Title;